// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_ReleaseResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Franchise-family release response — NO cost fields.
 *
 * ISP: disjoint from Admin family. No provider_cost_usd / markup /
 * raw_cost_brl / margin / fx_* fields.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_ReleaseResponseDados {
franquia_id: number
request_id: string
released_micro: number
balance_micro: number
reserved_micro: number
ledger_id?: number
}

export type AiCredits_ReleaseResponse = ApiResponse<AiCredits_ReleaseResponseDados>;

registerResponseContract('AiCredits_ReleaseResponse', {
  franquia_id:    { type: 'number',  required: true },
  request_id:     { type: 'string',  required: true },
  released_micro: { type: 'number',  required: true },
  balance_micro:  { type: 'number',  required: true },
  reserved_micro: { type: 'number',  required: true },
  ledger_id:      { type: 'number',  required: false },
})
